export default function loadingSelector(state: any) {
  return state.loading;
}
